import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchAgencies = ({ platformId }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: `/admin/platforms/${platformId}/agencies` })
    handleCall(req, resolve, reject)
  })
